import { render } from "./TotalShopping.vue?vue&type=template&id=dc03e82c"
import script from "./TotalShopping.vue?vue&type=script&lang=js"
export * from "./TotalShopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__